import { render, staticRenderFns } from "./PreviewFile.vue?vue&type=template&id=68509d7a&scoped=true"
import script from "./PreviewFile.vue?vue&type=script&lang=ts"
export * from "./PreviewFile.vue?vue&type=script&lang=ts"
import style0 from "./PreviewFile.vue?vue&type=style&index=0&id=68509d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68509d7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardActions,VIcon,VImg})
